import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpChangePasswordReturn implements ICommand
{

	public ReturnCode : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.ReturnCode = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.ReturnCode);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpChangePasswordReturn();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'ReturnCode(B)='+this.ReturnCode+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50118;
	}

	public getCmdName() : string
	{
		return 'SpChangePasswordReturn';
	}

}
